// Arbitrum
export const arbLendingPools = {
  WETH: "0x4c51FF6AF2EfC679A08C5A7377Bce18050f86CcB",
};

export const arbFactories = {
  WETH_USDC: "0xcd8d2e1fa4132749220ffeec165285ee33028d59",
};

export const arbBalanceVault = "";

export const arbHelper = "";

export const arbReferral = "";

export const arbRewardVesting = "";

export const arbFactoryController = "";

export const arbFarm = "";

export const arbFarmAction = "";

// Goerli
export const goerLendingPools = {
  WETH: "0x87Cd320BE0313E78D4Ce104a6eaFA6bea126d3D2",
};

export const goerFactories = {
  WETH_UNI: "0x04eac9D240E4266D070b4f3b349fdeEEb573Ef75",
  WETH_DAI: "0xD3442faE5E76cEB942787F2b9467fc947DAbE17e",
};

export const goerBalanceVault = "0x964A599A34369060beE9B14d2C5d52E8EC41dC17";

export const goerHelper = "0x4926dA8308503feE2516Fe56429a46cA98676b23";

export const goerReferral = "0x5541260D12C37578717312597344c2cfd52Ea800";

export const goerRewardVesting = "0x77F60F8B35912Bc4e0a98a3172828e440Bd9BbA7";

export const goerFactoryController =
  "0xCD461e42c3B757AcD46D246Cc334c5851f6f1e11";

export const goerFarm = "";

export const goerFarmAction = "";
